import styled from 'styled-components';
import { PriceLabel } from '../price-label';
import { layout } from '@prisjakt/ui-base';
import { Badge } from '@prisjakt/ui/badge';

export const StyledPriceLabel = styled(PriceLabel)`
  font-size: 16px;
  line-height: 24px;
  text-align: right;
`;

export const StyledSecondaryPrice = styled(PriceLabel).attrs({
  bold: false,
})`
  text-decoration: line-through;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  column-gap: ${layout.measurements.spacing050};
`;

export const PriceAndShipping = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  column-gap: ${layout.measurements.spacing050};
`;

export const StyledBadge = styled(Badge)`
  > span {
    font-weight: 400;
    font-size: 0.85em;
  }
`;
